import { httpService } from "../common/HttpService";
import { sessionService } from "../Session/SessionService";

class BetSlipService {
  constructor() { }

  calculate(betSlip, playerId) {

    betSlip.rgsSession = sessionService.getRGSSession(playerId);
    betSlip.fkCountryId = betSlip.rgsSession.extraData.region;
    return httpService.post("betslip/calculate", betSlip);
  }
  placeBet(betSlip, playerId) {
    betSlip.rgsSession = sessionService.getRGSSession(playerId);
    betSlip.fkCountryId = betSlip.rgsSession.extraData.region;
    return httpService.post("betslip/placebet", betSlip);
  }
}

export const betSlipService = new BetSlipService();
